import React from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import {arrowIconDownWhite} from 'app/constants/IconsConstants';
import {PhonesPropTypes} from 'app/constants/AppConstants';
import KeydownEnterLink from 'app/components/KeydownEnterLinkComponent';
import PhoneNumberComponent from 'app/components/PhoneNumberComponent';
import {parsePhone} from 'app/selectors/Helpers';

export default class PhonesComponent extends React.PureComponent {
	static propTypes = {
		oldPhones: PropTypes.arrayOf(PropTypes.string).isRequired,
		newPhones: PhonesPropTypes.isRequired,
		isMobileMenu: PropTypes.bool,
		onClick: PropTypes.func.isRequired
	}

	static defaultProps = {
		isMobileMenu: false
	}

	state = {
		isOpenedPhonesMenu: false
	}

	handleClickPhoneMenu = () => {
		this.setState(prevState => ({isOpenedPhonesMenu: !prevState.isOpenedPhonesMenu}));
	}

	handleKeyDownPhoneMenu = (event) => {
		if (event.keyCode === 13) {
			this.handleClickPhoneMenu();
		}
	}

	handlePhoneMenuOutsideClick = () => {
		if (this.state.isOpenedPhonesMenu) {
			this.setState({isOpenedPhonesMenu: false});
		}
	}

	renderOldPhoneNumbers = () => {
		const {oldPhones, onClick} = this.props;

		return oldPhones.length ? (
			<div className="header__phone">
				<div className="header__text">
					{_.map(oldPhones, (phone, index) => (
						<KeydownEnterLink
							type="plain"
							href={`tel:${parsePhone(phone)}`}
							key={index}
							data-icon="phone"
							onClick={onClick}
						>
							{phone}
						</KeydownEnterLink>
					))}
				</div>
			</div>
		) : null;
	}

	renderNewPhoneNumbers = () => {
		const {newPhones, isMobileMenu} = this.props;
		const {isOpenedPhonesMenu} = this.state;

		return newPhones.length && !isMobileMenu ? (
			<OutsideClickHandler onOutsideClick={this.handlePhoneMenuOutsideClick}>
				<div className="header__phone">
					<div className="header__phone__subinfo">
						{!!newPhones[0].value &&
							<PhoneNumberComponent
								phoneNumber={newPhones[0].value}
								comment={newPhones[0].comment}
							/>
						}
						<div
							tabIndex={0}
							className={`${newPhones[1].value || newPhones[2].value ?
								'header__phone-arrow' : 'header__phone-list-hide'
							}`}
							onClick={this.handleClickPhoneMenu}
							onKeyDown={this.handleKeyDownPhoneMenu}
						>
							{arrowIconDownWhite}
						</div>
					</div>
					<div
						className={`ui-select-content--bottom header__phone-list${isOpenedPhonesMenu ? '' : '-hide'}`}
					>
						{_.map(newPhones, (phone, key) => (
							!!phone.value &&
								<div key={key} className="ui-select-option">
									<PhoneNumberComponent
										phoneNumber={phone.value}
										comment={phone.comment}
										isPhoneList
									/>
								</div>
						))}
					</div>
				</div>
			</OutsideClickHandler>
		) : (
			<div className="header__phone">
				{_.map(newPhones, (phone, key) => (
					!!phone.value && <div className="header__text" key={key}>
						<KeydownEnterLink
							type="plain"
							href={`tel:${!!phone.value && parsePhone(phone.value)}`}
							data-icon="phone"
							onClick={this.props.onClick}
						>
							{phone.value}
						</KeydownEnterLink>
						{!!phone.comment &&
							<div className="header__text-addition">{phone.comment}</div>
						}
					</div>
				))}
			</div>);
	}

	render() {
		return this.props.newPhones.length ? this.renderNewPhoneNumbers() : this.renderOldPhoneNumbers();
	}
}
